import { CUSTOMER_API_BASE_URL } from "../utils";
import { useEffect, useState } from "react";

const DEFAULT_FLAGS = {
  googleLoginEnabled: false,
  wittyPrezoEnabled: false,
};

let currentFlags = { ...DEFAULT_FLAGS };
const listeners = new Set();

function normalizeFlags(rawFlags) {
  const source = rawFlags?.data && typeof rawFlags.data === "object"
    ? rawFlags.data
    : rawFlags;

  return {
    googleLoginEnabled: source?.google_login_enabled === true,
    wittyPrezoEnabled: source?.wittyprezo_enabled === true,
  };
}

function setFlags(nextFlags) {
  currentFlags = { ...DEFAULT_FLAGS, ...nextFlags };
  listeners.forEach((listener) => listener(currentFlags));
}

export async function fetchFlags() {
  try {
    const res = await fetch(`${CUSTOMER_API_BASE_URL}/Api/Config/appFlags`, {
      credentials: "include",
      cache: "no-store",
    });
    if (!res.ok) {
      throw new Error(`Flags request failed with ${res.status}`);
    }
    const data = await res.json();
    setFlags(normalizeFlags(data));
  } catch {
    setFlags(DEFAULT_FLAGS);
  }
  return currentFlags;
}

export function flags() {
  return currentFlags;
}

export function useAppFlags() {
  const [snapshot, setSnapshot] = useState(currentFlags);

  useEffect(() => {
    listeners.add(setSnapshot);
    return () => listeners.delete(setSnapshot);
  }, []);

  return snapshot;
}
